export function ChevronRightIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 12.5L8.14537 21.5L6.5 19.917L14.2093 12.5L6.5 5.08299L8.14537 3.5L17.5 12.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
